export const GET_DOCTORS_REQUEST = "DOCTOR.GET_DOCTORS_REQUEST";
export const GET_DOCTORS_SUCCESS = "DOCTOR.GET_DOCTORS_SUCCESS";
export const GET_DOCTORS_FAILURE = "DOCTOR.GET_DOCTORS_FAILURE";

export const GET_SINGLE_DOCTOR_REQUEST = "DOCTOR.GET_SINGLE_DOCTOR_REQUEST";
export const GET_SINGLE_DOCTOR_SUCCESS = "DOCTOR.GET_SINGLE_DOCTOR_SUCCESS";
export const GET_SINGLE_DOCTOR_FAILURE = "DOCTOR.GET_SINGLE_DOCTOR_FAILURE";

export const CREATE_DOCTOR_REQUEST = "DOCTOR.CREATE_DOCTOR_REQUEST";
export const CREATE_DOCTOR_SUCCESS = "DOCTOR.CREATE_DOCTOR_SUCCESS";
export const CREATE_DOCTOR_FAILURE = "DOCTOR.CREATE_DOCTOR_FAILURE";

export const CREATE_REVIEW_REQUEST = "DOCTOR.CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "DOCTOR.CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "DOCTOR.CREATE_REVIEW_FAILURE";
